module.exports = __webpack_public_path__ + "img/tilstand_hymo_kvalitetselement.c4bf1a24.jpg";